import { Button, Drawer, Form, Input, Select, Space, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo } from "../../../context";

const { Option } = Select;

const AddMerchantDrawer = ({ open, close, setLoading, getMerchantList }) => {
  const [provinceList, setProvinceList] = useState({ data: [], ready: false });
  const [cityList, setCityList] = useState({ data: [], ready: false });
  const [barangayList, setBarangayList] = useState({ data: [], ready: false });
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);

  const handleCreateCommissary = (values) => {
    const formdata = new FormData();
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/admin/new-merchant", formdata)
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data)
        if (data === "success") {
          rerunNotif("success", "Created new merchant successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getMerchantList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
    // console.log("FORMDATA", formdata);
  };

  const getAllProvinces = () => {
    axios
      .get("user/admin/province-list")
      .then((response) => {
        const data = response.data;
        setProvinceList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetCityByProvince = (value) => {
    var params = { province_description: value };
    setCityList({ data: [], ready: false });
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/admin/city-list", { params })
      .then((response) => {
        const data = response.data;
        setCityList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetBarangayByCity = (value) => {
    var params = { city_municipality_description: value };
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/admin/barangay-list", { params })
      .then((response) => {
        const data = response.data;
        setBarangayList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllProvinces();
  }, []);

  return (
    <Drawer
      title="Create a new merchant"
      width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleCreateCommissary}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Typography.Title level={3}>Personal Information</Typography.Title>
          <Form.Item
            name="reg_firstname"
            label="First Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set firstname" size="large" />
          </Form.Item>
          <Form.Item
            name="reg_lastname"
            label="Last Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set lastname" size="large" />
          </Form.Item>
          <Form.Item
            name="reg_contact_no"
            label="Contact Number"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set contact number" size="large" />
          </Form.Item>
          <Form.Item
            name="reg_province"
            label="Province"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select province"
              onChange={handleGetCityByProvince}
              showSearch
            >
              {provinceList.data.length > 0 ? (
                provinceList.data.map((data, index) => (
                  <Option value={data.province_description} key={index}>
                    {data.province_description}
                  </Option>
                ))
              ) : (
                <Option value="">No province found!</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="reg_city"
            label="City"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select city"
              onChange={handleGetBarangayByCity}
              showSearch
            >
              {cityList.data.length > 0 ? (
                cityList.data.map((data, index) => (
                  <Option
                    value={data.city_municipality_description}
                    key={index}
                  >
                    {data.city_municipality_description}
                  </Option>
                ))
              ) : (
                <Option value="">No city found!</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="reg_barangay"
            label="Barangay"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select barangay"
              // onChange={handleGetBarangayByCity}
              showSearch
              style={{ textTransform: "uppercase" }}
            >
              {barangayList.data.length > 0 ? (
                barangayList.data.map((data, index) => (
                  <Option
                    value={data.barangay_description}
                    key={index}
                    style={{ textTransform: "uppercase" }}
                  >
                    {data.barangay_description}
                  </Option>
                ))
              ) : (
                <Option value="">No barangay found!</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="reg_street"
            label="Street|House No.|Bldg. No.|Apartment"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea
              placeholder="Set street/house/bldg./apt"
              autoSize
              style={{ textTransform: "uppercase" }}
            />
          </Form.Item>
          <Typography.Title level={3}>Business Information</Typography.Title>
          <Form.Item
            name="business_name"
            label="Business Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set business" size="large" />
          </Form.Item>
          <Form.Item
            name="business_province"
            label="Province"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select province"
              onChange={handleGetCityByProvince}
              showSearch
            >
              {provinceList.data.length > 0 ? (
                provinceList.data.map((data, index) => (
                  <Option value={data.province_description} key={index}>
                    {data.province_description}
                  </Option>
                ))
              ) : (
                <Option value="">No province found!</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="business_city"
            label="City"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select city"
              onChange={handleGetBarangayByCity}
              showSearch
            >
              {cityList.data.length > 0 ? (
                cityList.data.map((data, index) => (
                  <Option
                    value={data.city_municipality_description}
                    key={index}
                  >
                    {data.city_municipality_description}
                  </Option>
                ))
              ) : (
                <Option value="">No city found!</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="business_barangay"
            label="Barangay"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select barangay"
              // onChange={handleGetBarangayByCity}
              showSearch
              style={{ textTransform: "uppercase" }}
            >
              {barangayList.data.length > 0 ? (
                barangayList.data.map((data, index) => (
                  <Option
                    value={data.barangay_description}
                    key={index}
                    style={{ textTransform: "uppercase" }}
                  >
                    {data.barangay_description}
                  </Option>
                ))
              ) : (
                <Option value="">No barangay found!</Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="business_street"
            label="Street|House No.|Bldg. No.|Apartment"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea
              placeholder="Set street/house/bldg./apt"
              autoSize
              style={{ textTransform: "uppercase" }}
            />
          </Form.Item>
          <Typography.Title level={3}>Set Credentials</Typography.Title>
          <Form.Item
            name="username"
            label="Username"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set username" size="large" />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "5px" }}
            name="password"
            label="Password"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password
              // prefix={<LockOutlined />}
              placeholder="Set password"
              size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddMerchantDrawer;
